import { useState } from 'react';

import {
  ErrorOutline,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  People,
  Assignment,
  Quiz,
  DoNotDisturb,
  Publish,
} from '@mui/icons-material';
import {
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Typography,
} from '@mui/material';

import { Filter, FilterApplied } from 'assets/SVGs';
import { SidebarButton } from 'components/SidebarButton';
import { useCandidateContext } from 'hooks';
import { EmployerTableGlobalFilterOptions } from 'types/Candidate';

import { SidebarWrapper } from './styledComponents';

interface SidebarProps {
  setFilter: React.Dispatch<
    React.SetStateAction<EmployerTableGlobalFilterOptions>
  >;
  filter: EmployerTableGlobalFilterOptions;
  globalFiltersApplied: boolean;
}

export const EmployerTableSidebar: React.FC<SidebarProps> = ({
  setFilter,
  filter,
}) => {
  const [expanded, setExpanded] = useState(true);
  const { filterSummary } = useCandidateContext();
  return (
    <SidebarWrapper expanded={expanded}>
      <header>
        <IconButton
          onClick={() => setExpanded(!expanded)}
          key='expand'
          role='button'
          aria-label='expand and close filter'
          aria-expanded
        >
          {expanded ? (
            <KeyboardArrowLeft fontSize='medium' />
          ) : (
            <KeyboardArrowRight fontSize='medium' />
          )}
        </IconButton>
      </header>

      <List>
        <ListItem key='filters'>
          <ListItemIcon>
            {filter !== 'all' ? <FilterApplied /> : <Filter />}
          </ListItemIcon>
          {expanded && <Typography variant='h5'>Filter</Typography>}
        </ListItem>
        <Divider />
        <SidebarButton
          onClick={() => setFilter('unchecked')}
          selected={filter === 'unchecked'}
          title='Unchecked'
          expanded={expanded}
          summary={filterSummary.unchecked}
        >
          <Assignment fontSize='medium' />
        </SidebarButton>
        <SidebarButton
          onClick={() => setFilter('inProgress')}
          selected={filter === 'inProgress'}
          title='In Progress'
          expanded={expanded}
          summary={filterSummary.inProgress}
        >
          <ErrorOutline fontSize='medium' />
        </SidebarButton>
        <SidebarButton
          onClick={() => setFilter('didNotWorkForUs')}
          selected={filter === 'didNotWorkForUs'}
          title='Did Not Work For Us'
          expanded={expanded}
          summary={filterSummary.didNotWorkForUs}
        >
          <DoNotDisturb fontSize='medium' />
        </SidebarButton>
        <SidebarButton
          onClick={() => setFilter('insufficientData')}
          selected={filter === 'insufficientData'}
          title='Insufficient Data'
          expanded={expanded}
          summary={filterSummary.insufficientData}
        >
          <Quiz fontSize='medium' />
        </SidebarButton>
        <SidebarButton
          onClick={() => setFilter('all')}
          selected={filter === 'all'}
          title='All Candidates'
          expanded={expanded}
          summary={filterSummary.all}
        >
          <People fontSize='medium' />
        </SidebarButton>
        <Divider />
        <SidebarButton
          onClick={() => setFilter('verified')}
          selected={filter === 'verified'}
          title='Verified Employees'
          expanded={expanded}
          summary={filterSummary.verified}
        >
          <Publish fontSize='medium' />
        </SidebarButton>
      </List>
    </SidebarWrapper>
  );
};
